import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import StaffLeaveDetTbFilters from "../admin/StaffLeaveDetTbFilters";
import LeaveDates from "../admin/LeaveDates";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { convertStraight } from "../../common-data/Converts";
import {
  fetchApprovalManagerData,
  fetchStaffLeaveStatsData,
  fetchStaffLeavesData,
} from "../../../redux/reducers/apiSlice";
import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import CommonMobTb from "../mobile-version/CommonMobTb";
import DetailListings from "../detail/DetailListings";
import DetailModHeader from "../../common-components/DetailModHeader";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const StaffListings = ({ userInfoData, isOpenPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { staffLeaves, staffLeaveStats, approvalManager } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isClubManager = userInfoData?.is_club_manager;
  const isManagerRole = checkIsManagerRole(userInfoData);

  const iniAM = {
    isApprovalManager: false,
    approvalManagerFor: "",
  };
  const [approvalManagerInfo, setApprovalManagerInfo] = useState(iniAM);
  const [isPage, setIsPage] = useState(0);
  const initialFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: userInfoData?.gym_name || "",
            value: userInfoData?.gym_id || "",
          }
        : "",
    selectedOtherUsers:
      !isAdmin && !isManagerRole && !isClubManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.user_id || userInfoData?.uid || "",
          }
        : "",
    selectedLeaveStatus: "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    user_id: allFilters.selectedOtherUsers?.value || "",
    approval_status: allFilters.selectedLeaveStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    staffLeavesStats: {},
    staffLeavesData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
    leaveDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const sortedStaffLeaveDetails =
    tbDatas.staffLeavesData?.length > 0
      ? [...tbDatas.staffLeavesData].sort((a, b) => {
          const dateA = new Date(a.leave_date);
          const dateB = new Date(b.leave_date);
          return dateB - dateA;
        })
      : [];

  const approvalManagerFor =
    (isOpenPage || approvalManagerInfo.isApprovalManager) &&
    sortedStaffLeaveDetails?.length > 0
      ? sortedStaffLeaveDetails[0]?.account_type === "receptionist"
        ? "Sales Executive"
        : sortedStaffLeaveDetails[0]?.account_type
      : "";

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, userInfoData: userInfoData },
    });
  };

  function getStaffLeaves(filters) {
    dispatch(
      fetchStaffLeavesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getStaffLeavesStats(filters) {
    const updatedFilters = {
      ...filters,
      filter_type: "staff_leave_stats",
    };

    dispatch(
      fetchStaffLeaveStatsData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  function callCombinedFunctions() {
    getStaffLeaves(filters);
    getStaffLeavesStats(filters);
  }

  function getApprovalManagerList(filter) {
    dispatch(
      fetchApprovalManagerData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    const filter = {
      user_id: userInfoData?.uid || userInfoData?.user_id,
    };

    if (filter) {
      getApprovalManagerList(filter);
    }
  }, []);

  useEffect(() => {
    if (approvalManager?.status && approvalManager?.data?.length > 0) {
      setApprovalManagerInfo((prevs) => ({
        ...prevs,
        isApprovalManager: true,
        approvalManagerFor: approvalManager.data?.[0]?.for_ac_type,
      }));
    } else {
      setApprovalManagerInfo(iniAM);
    }
  }, [approvalManager]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      user_id: allFilters.selectedOtherUsers?.value || "",
      approval_status: allFilters.selectedLeaveStatus?.value || "",
    }));
  }, [allFilters, isPage, approvalManagerInfo.isApprovalManager]);

  useEffect(() => {
    getStaffLeaves(filters);
    getStaffLeavesStats(filters);
  }, [filters]);

  useEffect(() => {
    if (staffLeaveStats?.status && staffLeaveStats?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: staffLeaveStats.data?.[0],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: {},
      }));
    }
  }, [staffLeaveStats]);

  useEffect(() => {
    if (staffLeaves?.status && staffLeaves?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: staffLeaves.data || [],
        pagination: staffLeaves?.pagination || [],
        staffLeaveStats: {},
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: [],
        pagination: [],
        staffLeaveStats: {},
      }));
    }
  }, [staffLeaves]);

  const staffTbColumns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={(e) =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                leaveDetails:
                  row?.leave_dates_with_status?.length > 0
                    ? row.leave_dates_with_status
                    : [],
                cardType: "view",
                rowData: row,
              }))
            }
            style={{
              border:
                row?.leave_dates_with_status?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color:
                row?.leave_dates_with_status?.length > 0
                  ? "#bc0909"
                  : "#9C9C9C",
              borderRadius: "12px",
              cursor:
                row?.leave_dates_with_status?.length > 0
                  ? "pointer"
                  : "not-allowed",
            }}
            disabled={row?.leave_dates_with_status?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color:
                  row?.leave_dates_with_status?.length > 0
                    ? "#bc0909"
                    : "#9C9C9C",
                width: "20px",
                height: "20px",
              }}
            >
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Staff Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"} <small>({row?.account_type || ""})</small>
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "matrix_status",
      text: "Leave Terms fulfilled",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.matrix_status === "matched" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_action_pending",
      text: "Approval Action",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_action_pending === "true" ? (
              <CrossCircleIcon />
            ) : (
              <CheckCircleIcon />
            )}
          </span>
        );
      },
    },
    // {
    //   dataField: "reporting_manager_name",
    //   text: "Approval Manager",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.reporting_manager_name || "NA"}
    //         <br />
    //         <small style={{ textTransform: "lowercase" }}>
    //           {row?.reporting_manager_mobile || ""}
    //           <br />
    //           {row?.reporting_manager_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "aprv_rej_by_name",
    //   text: "Approved/Rejected By",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.aprv_rej_by_name || "NA"}
    //         <br />
    //         <small style={{ textTransform: "lowercase" }}>
    //           {row?.aprv_rej_by_mobile || ""}
    //           <br />
    //           {row?.aprv_rej_by_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "gym_name",
    //   text: "Gym Name",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
    //     );
    //   },
    // },
    {
      dataField: "apply_date",
      text: "Apply Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.apply_date ? convertStraight(row.apply_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "leave_category_name",
      text: "leave category name",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background: "#157EF9",
              color: "#FFF",
            }}
          >
            {row?.leave_category_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total_leave_days_approved",
      text: "Approved/Rejected Leaves",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            <small
              style={{
                background: "#379C00",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_approved || 0}
            </small>{" "}
            /{" "}
            <small
              style={{
                background: "#F13434",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_rejected || 0}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "days_before",
    //   text: "Max Leave(Monthly)",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.no_ofdays || 0} Day(S)</span>;
    //   },
    // },
    // {
    //   dataField: "days_before",
    //   text: "Apply Before",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.days_before || 0} Day(S)</span>;
    //   },
    // },
    // {
    //   dataField: "is_paid",
    //   text: "Paid Leave",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data icon">
    //         {row?.is_paid ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "doc_required",
    //   text: "doc required",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data icon">
    //         {row?.doc_required ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "approval_required",
    //   text: "approval required",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data icon">
    //         {row?.approval_required ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "description",
    //   text: "Remarks",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row.description?.length <= 15 ? (
    //           row.description
    //         ) : row.description?.length >= 15 ? (
    //           <>
    //             {row.description?.substring(0, 15)}
    //             <b
    //               style={{ cursor: "pointer" }}
    //               onClick={() =>
    //                 setModValues((prevs) => ({
    //                   ...prevs,
    //                   isModOpen: true,
    //                   cardType: "description",
    //                   description: row.description,
    //                 }))
    //               }
    //             >
    //               ...Read More
    //             </b>
    //           </>
    //         ) : (
    //           "NA"
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "salary",
    //   text: "Staff Salary(Monthly)",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         ₹{convertThenFormat(row?.salary || 0)}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "deducted_salary",
    //   text: "Deducted Amount",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         ₹{convertThenFormat(row?.deducted_salary || 0)}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_used",
    //   text: "Taken/Total Leaves(Year)",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data bold">
    //         {row?.total_leave_days_used || 0}/{row?.yearly_leave || 0}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_remaining",
    //   text: "Remaining Leaves(Year)",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.total_leave_days_remaining || 0}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "action",
      text: "view details",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "view_details",
                rowData: row,
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16"
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "description" ||
            modValues.cardType === "view_details"
              ? "mod-width-50p"
              : ""
          }`}
        >
          {modValues.cardType === "view" ? (
            <DetailModHeader
              info={modValues.rowData}
              onClose={closeModal}
              isOnlySubscription={true}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.cardType === "view"
                  ? "Leave Details"
                  : modValues.cardType === "description"
                  ? "Remarks"
                  : modValues.cardType === "view_details"
                  ? `${modValues.rowData?.user_name || ""} Leave Details`
                  : modValues.cardType?.replace(/_/g, " ")
              } `}
              onClose={closeModal}
            />
          )}

          {modValues.cardType === "view" ? (
            <LeaveDates
              userInfoData={userInfoData}
              leaveDetails={modValues.leaveDetails}
              rowData={modValues.rowData}
              callFunction={() => callCombinedFunctions()}
              closeModal={closeModal}
              approvalManagerInfo={approvalManagerInfo}
            />
          ) : modValues.cardType === "description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.description || "No Content Available"}
              </p>
            </div>
          ) : modValues.cardType === "view_details" ? (
            <>
              <DetailListings row={modValues.rowData} />
              {/* <LMAdminViewDetails tbData={[modValues.rowData]} /> */}
            </>
          ) : null}
        </div>
      </Modal>

      {isOpenPage ? (
        <BackAddBtns
          onClickBack={isOpenPage ? handleBack : null}
          isCustom={isOpenPage}
          onClickReload={() => callCombinedFunctions()}
        />
      ) : null}

      <StaffLeaveDetTbFilters
        userInfoData={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        prevGymId={filters.gym_id}
        staffLeaveStats={tbDatas.staffLeavesStats}
        isLMAdminDate={true}
        approvalManagerFor={
          (approvalManagerInfo.isApprovalManager || isOpenPage) &&
          (approvalManagerInfo.approvalManagerFor || approvalManagerFor)
            ? approvalManagerInfo.approvalManagerFor || approvalManagerFor
            : null
        }
      />

      <CommonMobTb
        tbData={sortedStaffLeaveDetails}
        tbColumns={staffTbColumns}
        tbPaignation={tbDatas.pagination}
        isPage={isPage}
        setIsPage={setIsPage}
        setModValues={setModValues}
        userInfoData={userInfoData}
      />
    </>
  );
};

export default StaffListings;
